/* ------------------------------------------------------------------
   A club's playing season.

   Most clubs play July to June, not January to December, so filtering by
   calendar year split each season in half. A season is named by the year
   it starts — "2025" is the season beginning in the club's start month of
   2025 — which keeps the year filter's values exactly what they were. A
   club that has not set a start month plays the calendar year.

   The server has the same rules in server/utils/season.js, for the club
   leaderboard. The two have to agree.
   ------------------------------------------------------------------ */

export const MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'];

export const seasonStartMonthOf = (club) => {
  const n = parseInt(club && club.seasonStartMonth, 10);
  return Number.isInteger(n) && n >= 1 && n <= 12 ? n : 1;
};

/**
 * The season a date falls in, as the year it started. Read from the string
 * when it is 'YYYY-MM-DD…' — the competition dates are DATEONLY, and going
 * through Date would move a 1 July start into June for anyone west of UTC.
 */
export const seasonOf = (value, startMonth = 1) => {
  if (!value) return null;
  let y; let m;
  const match = /^(\d{4})-(\d{2})/.exec(String(value));
  if (match) {
    y = Number(match[1]); m = Number(match[2]);
  } else {
    const d = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(d.getTime())) return null;
    y = d.getFullYear(); m = d.getMonth() + 1;
  }
  return m >= startMonth ? y : y - 1;
};

export const currentSeason = (startMonth = 1, now = new Date()) => seasonOf(now, startMonth);

/** "2026" for a calendar-year club; "2025–26" for one whose season crosses New Year. */
export const seasonLabel = (startYear, startMonth = 1) => {
  const y = Number(startYear);
  if (!Number.isInteger(y)) return String(startYear);
  if (startMonth === 1) return String(y);
  return `${y}–${String(y + 1).slice(-2)}`;
};

/** True when `filter` is 'all', or the date falls in that season. */
export const inSeason = (value, filter, startMonth = 1) => {
  if (!filter || filter === 'all') return true;
  return seasonOf(value, startMonth) === Number(filter);
};
